import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useTeamsOverviewSection} from './TeamsOverviewSection.hook';
import {TeamsOverviewSectionProps} from './TeamsOverviewSection.types';

export const TeamsOverviewSection = ({
  currentUserCompetency = '',
  onShowReport = () => {},
  onShowInfoPopover = () => {},
  teamsExecutiveDirector = 0,
  teamsFibc = 0,
  teamsFibl = 0,
  teamsSenior = 0,
  screenName = '',
}: TeamsOverviewSectionProps) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {onInfoPress, tt, onItemPress, listItems, ts} = useTeamsOverviewSection(
    {
      currentUserCompetency,
      onShowReport,
      onShowInfoPopover,
      teamsExecutiveDirector,
      teamsFibc,
      teamsFibl,
      teamsSenior,
      screenName,
    },
  );

  return (
    <MetricSection
      analyticsTitle="Teams Overview"
      testID={MetricsSection.metricSectionTeamsOverview}
      title={tt('heading', 'Teams Overview')}
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Teams Overview Section Information button',
      )}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default TeamsOverviewSection;
